import {
  TADARIDA_USER_PERSIST_KEY,
  UserState,
  getUserDataFromCookies,
} from '@aboutyou/user';

export const getBrowserAuthToken = (cookieDomain: string) => {
  const userState = getUserDataFromCookies<UserState>({
    storageKey: TADARIDA_USER_PERSIST_KEY,
    cookieDomain,
  });

  return userState?.token;
};
